// extracted by mini-css-extract-plugin
export default {"dl-button":"DownloadBtn_dl-button__ea60S","icon":"DownloadBtn_icon__-uLQg"};